export enum CONTACT_TYPE {
  CONTACT,
  COMPANY,
  AGENT,
  AGENCY,
  CARRIER,
}
